import { ScrollingModule } from '@angular/cdk/scrolling';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_LEGACY_DIALOG_DEFAULT_OPTIONS as MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NotificationMessagesModule } from '@modules/notification-messages/notification-messages.module';
import { NotificationQueueComponent } from '@modules/notification-queue/component/notification-queue.component';
import { ServiceRequestNotificationComponent } from '@modules/notification-queue/modules/service-request-notification/component/service-request-notification.component';
import { NguCarouselModule } from '@ngu/carousel';
import * as Sentry from '@sentry/angular';
import { ChartsModule } from 'ng2-charts';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { TagInputModule } from 'ngx-chips';
import { CookieService } from 'ngx-cookie-service';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { SharedUiModule } from './@shared/shared-ui.module';
import { AssignRejectDialogComponent } from './MaterialDialogs/assign-reject-dialog/assign-reject-dialog.component';
import { AddViewCallFlowComponent } from './MaterialDialogs/call-flow/add-view-call-flow/add-view-call-flow.component';
import { CallFlowDetailsComponent } from './MaterialDialogs/call-flow/call-flow-details/call-flow-details.component';
import { CheckListDetailsComponent } from './MaterialDialogs/check-list/check-list-details/check-list-details.component';
import { FinanceDiagnosticToolDialogComponent } from './MaterialDialogs/finance-diagnostic-tool-dialog/finance-diagnostic-tool-dialog.component';
import { LegTimeStampDialogComponent } from './MaterialDialogs/leg-time-stamp-dialog/leg-time-stamp-dialog.component';
import { SplitRecordDialogComponent } from './MaterialDialogs/split-record-dialog/split-record-dialog.component';
import { TrackItineraryDialogComponent } from './MaterialDialogs/track-itinerary-dialog/track-itinerary-dialog.component';
import { TripDetailsDialogComponent } from './MaterialDialogs/trip-details-dialog/trip-details-dialog.component';
import { InvoicePreviewModalComponent } from './ReusableComponent/invoice-preview-modal/invoice-preview-modal.component';
import { PdfPreviewDialogComponent } from './ReusableComponent/pdf-preview-dialog/pdf-preview-dialog.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthguradServiceService } from './authgurad-service.service';
import { CustomerListComponent } from './pages/customer-list/customer-list.component';
import { LoginComponent } from './pages/login/login.component';
import { ManageVendorComponent } from './pages/manage-vendor/manage-vendor.component';
import { PreviewItineraryDetailComponent } from './pages/preview-itinerary-detail/preview-itinerary-detail.component';
import { SafariDatePipePipe } from './pipe/safari-date-pipe.pipe';
import { TotalWorkingTimePipe } from './pipe/total-working-time.pipe';
import { USPhoneNumberPipe } from './pipe/usPhoneNUmberFormate.pipe';
import { NotificationModule } from './shared/modules/notification/notification.module';
import { HttpInterceptorService } from './auth/services/http-interceptor.service';
import { NoteFeedbackFileComponent } from './ReusableComponent/note-feedback-file/note-feedback-file.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CustomerListComponent,
    PreviewItineraryDetailComponent,
    ManageVendorComponent,
    USPhoneNumberPipe,
    SafariDatePipePipe,
    TotalWorkingTimePipe,
    AddViewCallFlowComponent,
    CallFlowDetailsComponent,
    CheckListDetailsComponent,
    InvoicePreviewModalComponent,
    TripDetailsDialogComponent,
    TrackItineraryDialogComponent,
    LegTimeStampDialogComponent,
    AssignRejectDialogComponent,
    FinanceDiagnosticToolDialogComponent,
    SplitRecordDialogComponent,
    PdfPreviewDialogComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    NguCarouselModule,
    ScrollingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    MatNativeDateModule,
    Ng2GoogleChartsModule,
    AppRoutingModule,
    SharedUiModule,
    SelectDropDownModule,
    TagInputModule,
    NotificationModule,
    ServiceRequestNotificationComponent,
    NotificationMessagesModule,
    NotificationQueueComponent,
    NoteFeedbackFileComponent,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
    CookieService,
    DatePipe,
    AuthguradServiceService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
